import { type ReduxUser, type CommunityListItem } from 'models';
import { useState, useMemo } from 'react';

import { canRequestEventInCommunity } from 'permissions';
import { TelehealthButton, type TelehealthButtonType } from 'ui';

import TelehealthRequestFormModal from './TelehealthRequestFormModal';
import TelehealthRequestNoticeModal from './TelehealthRequestNoticeModal';

type P = {
  viewer: ReduxUser;
  communities: CommunityListItem[];
  buttonType: TelehealthButtonType;
  communityId?: string;
};

const TelehealthRequest = ({ viewer, communities, buttonType, communityId }: P) => {
  const [isNoticeModalOpened, setIsNoticeModalOpened] = useState<boolean>(false);
  const [isFormModalOpened, setIsFormModalOpened] = useState<boolean>(false);

  const medicalCommunities = useMemo(() => {
    return communities.filter((community) =>
      canRequestEventInCommunity({
        viewer,
        community,
        eventType: 'telehealth_visit',
      }),
    );
  }, [viewer, communities]);

  const onNoticeSubmit = () => {
    setIsNoticeModalOpened(false);
    setIsFormModalOpened(true);
  };

  const handleClick = () => {
    setIsNoticeModalOpened(true);
  };

  return (
    <>
      <TelehealthButton buttonType={buttonType} onClick={handleClick}>
        Request telehealth visit
      </TelehealthButton>
      <TelehealthRequestNoticeModal
        isOpened={isNoticeModalOpened}
        onClose={() => {
          setIsNoticeModalOpened(false);
        }}
        onSubmit={onNoticeSubmit}
      />
      <TelehealthRequestFormModal
        communityId={communityId}
        isOpened={isFormModalOpened}
        communities={medicalCommunities}
        onClose={() => setIsFormModalOpened(false)}
      />
    </>
  );
};

export default TelehealthRequest;
